import {
  AutoComplete,
  Form,
  Input,
  message,
  Row,
  Select,
  Space,
  Table,
  Tag,
} from "antd";
import TextArea from "antd/lib/input/TextArea";
import axios from "axios";
import React, { useContext, useEffect, useRef, useState } from "react";
import { ProjectFileApi } from "../../../../api";
import { getFileSize } from "../../../../utils/Misc/fileSizeChecker";
import { ImageUpload } from "./imageUpload";
import "./Quote.style.css";
import { mdCategories } from "../../../../api/estimate.api";

const EditableContext = React.createContext(null);

const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

const EditableCell = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);
  const form = useContext(EditableContext);
  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    });
  };
  const save = async () => {
    try {
      const values = await form.validateFields();
      toggleEdit();
      handleSave({
        ...record,
        ...values,
      });
    } catch (errInfo) {
      console.log("Save failed:", errInfo);
    }
  };
  let childNode = children;
  if (editable) {
    childNode = editing ? (
      <Form.Item
        style={{
          margin: 0,
        }}
        name={dataIndex}
        rules={[
          {
            required: false,
            message: `${title} is required.`,
          },
        ]}
      >
        <Input ref={inputRef} onPressEnter={save} onBlur={save} />
      </Form.Item>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{
          paddingRight: 0,
          minWidth: 30,
        }}
        onClick={toggleEdit}
      >
        {children}
      </div>
    );
  }
  return <td {...restProps}>{childNode}</td>;
};

const EditableItemTable = ({
  dataSource,
  setDataSource,
  handleAdd,
  missingFields,
  ...props
}) => {
  const { Option } = Select;
  const [fileUploading, setFileUploading] = useState(false);
  const [categories, setCategories] = useState([]);

  const handleDelete = (id) => {
    const newData = dataSource.filter((item) => item.id !== id);
    setDataSource(newData);
  };

  // useEffect(() => {}, [missingFields]);

  const onDocumentAdd = async (index, file) => {
    try {
      setFileUploading(true);
      const result = await Promise.all(
        Object.keys(file).map((key) => {
          console.log("KK", key, file[key]);
          const formData = new FormData();
          formData.append("file", file[key], file[key].name);
          formData.append("file_name", file[key].name);
          formData.append("project", props.project?.id);
          formData.append("file_size", getFileSize(file[key]?.size));
          return axios
            .post(ProjectFileApi, formData)
            .then((res) => {
              const newData = [...dataSource];
              newData[index].item_image = res?.data?.file;
              setDataSource(newData);
              message.success("Files Upload Successfully !");
            })
            .catch((e) => {
              console.log("e", { e });
              message.error("Something went wrong!");
            });
        })
      );

      // if (Array.isArray(file)) {
      //   const result = await Promise.all(
      //     file.map(async (file) => uploadDocument(file))
      //   );
      //   setFileList([...fileList, ...result]);
      //   setFinalValue({
      //     ...finalValue,
      //     documents: [...finalValue.documents, ...result],
      //   })
      // } else {
      //   const result = await uploadDocument(file);
      //   setFileList([...fileList, result]);
      //   setFinalValue({
      //     ...finalValue,
      //     documents: [...finalValue.documents, result],
      //   });
      // }
    } catch (e) {
      console.log("i-log> ", e);
    } finally {
      setFileUploading(false);
    }
  };

  const taxTypes = [
    {
      id: 1,
      label: "None",
      value: "none",
    },
    {
      id: 2,
      label: "CGST/SGST",
      value: "cgst_sgst",
    },
    {
      id: 4,
      label: "IGST",
      value: "igst",
    },
  ];

  React.useEffect(() => {
    mdCategories().then((res) => {
      console.log("debug>>> categories", res);
      setCategories(res);
    });
  }, []);

  useEffect(() => {}, [dataSource]);

  const categoryOptions = React.useMemo(
    () =>
      categories.map((category) => ({
        value: category?.category_name,
      })),
    [categories]
  );

  const defaultColumns = [
    {
      title: "S.no",
      dataIndex: "index",
      render: (value, data, index) => <>{index + 1}</>,
    },
    {
      title: "Item",
      dataIndex: "boq_item",
      render: (value, data, index) => (
        <>
          <TextArea
            className="item-input-table w-100"
            style={{ minWidth: 160 }}
            value={data?.boq_item}
            onChange={(e) => {
              handleSave({ ...data, boq_item: e.target.value });
            }}
            status={
              missingFields
                ?.find((item) => index === item?.index)
                ?.missingFields?.includes("boq_item")
                ? "error"
                : ""
            }
          />
          {missingFields
            ?.find((item) => index === item?.index)
            ?.missingFields?.includes("boq_item") && (
            <div style={{ color: "red" }}>Invalid value</div>
          )}
        </>
      ),
    },
    {
      title: "Category",
      dataIndex: "category_name",
      render: (value, data, index) => (
        <>
          {/* <Input
            className="item-input-table"
            value={data?.category_name}
            style={{ minWidth: 70 }}
            onChange={(e) => {
              handleSave({ ...data, category_name: e.target.value });
            }}
          /> */}
          <AutoComplete
            className="item-input-table"
            style={{ minWidth: 120 }}
            options={categoryOptions}
            value={data?.category_name}
            onChange={(category) => {
              handleSave({ ...data, category_name: category });
            }}
            status={
              missingFields
                ?.find((item) => index === item?.index)
                ?.missingFields?.includes("category")
                ? "error"
                : ""
            }
            filterOption={(inputValue, option) =>
              option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !==
              -1
            }
          />
          {missingFields
            ?.find((item) => index === item?.index)
            ?.missingFields?.includes("category") && (
            <div style={{ color: "red" }}>Invalid value</div>
          )}
        </>
      ),
    },
    {
      title: "Brand",
      dataIndex: "brand",
      render: (value, data, index) => (
        <>
          <Input
            className="item-input-table"
            value={data?.brand}
            style={{ minWidth: 100 }}
            onChange={(e) => {
              handleSave({ ...data, brand: e.target.value });
            }}
            status={
              missingFields
                ?.find((item) => index === item?.index)
                ?.missingFields?.includes("brand")
                ? "error"
                : ""
            }
          />
          {missingFields
            ?.find((item) => index === item?.index)
            ?.missingFields?.includes("brand") && (
            <div style={{ color: "red" }}>Invalid value</div>
          )}
        </>
      ),
    },
    {
      title: "MRP",
      dataIndex: "mrp",
      render: (value, data, index) => (
        <>
          <Input
            className="item-input-table"
            value={data?.mrp}
            style={{ minWidth: 70 }}
            required
            type="number"
            onWheel={(event) => event.currentTarget.blur()}
            disabled={data?.disabled}
            onChange={(e) => {
              if (Number(e.target.value) || e.target.value == "") {
                handleSave({
                  ...data,
                  mrp: e.target.value == "" ? 0 : Number(e.target.value),
                });
              } else {
                handleSave({
                  ...data,
                  mrp: 0,
                });
              }
            }}
          />
        </>
      ),
    },
    {
      title: "Discount (by vendor)",
      render: (value, data, index) => {
        var total = parseFloat(
          ((parseFloat(value?.mrp ?? 0, 2) -
            parseFloat(value?.unit_selling_price ?? 0, 2) * 1.18) *
            100) /
            parseFloat(value?.mrp ?? 1, 2)
        );
        return (
          <span className="item-input-table" style={{ minWidth: 100 }}>
            {value?.mrp != 0 && value?.mrp != "" && value?.mrp
              ? isNaN(total)
                ? "-"
                : total?.toFixed(2) + "%"
              : "-"}
          </span>
        );
      },
    },
    {
      title: "Landing Price(w/o gst)",
      dataIndex: "unit_selling_price",
      render: (value, data, index) => (
        <>
          <Input
            className="item-input-table"
            style={{ minWidth: 70 }}
            type="number"
            onWheel={(event) => event.currentTarget.blur()}
            value={data?.unit_selling_price}
            disabled={data?.disabled}
            onChange={(e) => {
              if (Number(e.target.value) || e.target.value == "") {
                handleSave({
                  ...data,
                  unit_selling_price:
                    e.target.value == "" ? 0 : Number(e.target.value),
                });
              } else {
                handleSave({
                  ...data,
                  unit_selling_price: 0,
                });
              }
            }}
            status={
              missingFields
                ?.find((item) => index === item?.index)
                ?.missingFields?.includes("unit_selling_price")
                ? "error"
                : ""
            }
          />
          {missingFields
            ?.find((item) => index === item?.index)
            ?.missingFields?.includes("unit_selling_price") && (
            <div style={{ color: "red" }}>Invalid value</div>
          )}
        </>
      ),
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      render: (value, data, index) => (
        <>
          <Input
            className="item-input-table"
            value={data?.quantity}
            style={{ minWidth: 50 }}
            type="number"
            onWheel={(event) => event.currentTarget.blur()}
            onChange={(e) => {
              if (Number(e.target.value) || e.target.value == "") {
                handleSave({
                  ...data,
                  quantity: e.target.value == "" ? 0 : Number(e.target.value),
                });
              } else {
                handleSave({
                  ...data,
                  quantity: 0,
                });
              }
            }}
            status={
              missingFields
                ?.find((item) => index === item?.index)
                ?.missingFields?.includes("quantity")
                ? "error"
                : ""
            }
          />
          {missingFields
            ?.find((item) => index === item?.index)
            ?.missingFields?.includes("quantity") && (
            <div style={{ color: "red" }}>Invalid value</div>
          )}
        </>
      ),
    },
    {
      title: "Unit",
      dataIndex: "unit",
      render: (value, data, index) => (
        <>
          <Input
            className="item-input-table"
            value={data?.unit}
            style={{ minWidth: 60 }}
            onChange={(e) => {
              handleSave({ ...data, unit: e.target.value });
            }}
            status={
              missingFields
                ?.find((item) => index === item?.index)
                ?.missingFields?.includes("unit")
                ? "error"
                : ""
            }
          />
        </>
      ),
    },
    // {
    //   title: "Markup %",
    //   dataIndex: "margin",
    //   render: (value, data, index) => (
    //     <>
    //       <span className="item-input-table" style={{ minWidth: 140 }}>
    //         {data?.margin?.toFixed(2)}
    //       </span>
    //     </>
    //   ),
    // },
    {
      title: "GM %",
      render: (value, data, index) => {
        return (
          <Input
            className="item-input-table"
            value={parseFloat(data?.gross_margin)?.toFixed(2)}
            style={{ minWidth: 60 }}
            type="number"
            onWheel={(event) => event.currentTarget.blur()}
            disabled={data?.disabled && props?.user?.contact != "9167428938"}
            onChange={(e) => {
              console.log(e.target.value);
              var gross_margin = e.target.value;
              var margin = 0;
              if (!isNaN(gross_margin)) {
                margin = gross_margin / (1 - gross_margin / 100);
              } else {
                margin = "";
              }
              if (Number(margin) || margin == "") {
                handleSave({
                  ...data,
                  margin: margin ?? 0,
                  gross_margin: gross_margin,
                });
              } else {
                handleSave({
                  ...data,
                  margin: 0,
                  gross_margin: 0,
                });
              }
            }}
          />
        );
      },
    },
    {
      title: "Cost Price (w/o GST)",
      width: 140,
      render: (value, data, index) => {
        var total = parseFloat(
          parseFloat(value?.unit_selling_price, 2) +
            (parseFloat(value?.unit_selling_price, 2) *
              parseFloat(value?.margin, 2)) /
              100
        );
        return (
          <span className="item-input-table" style={{ minWidth: 140 }}>
            {total?.toFixed(2)}
          </span>
        );
      },
    },
    {
      title: "Tax",
      key: "tax",
      render: (value, data, index) => (
        <Space>
          <Select
            className="item-input-table"
            onChange={(e) => {
              console.log("value", value, data, index);
              // data.unit_selling_price = parseFloat(
              //   data?.md_price_gst / (1 + e / 100)
              // ).toFixed(2);
              // console.log("data.unit_selling_price", data.unit_selling_price);

              handleSave({
                ...data,
                tax_value: e,
                // unit_selling_price: data.unit_selling_price,
              });
              // onChange(e, data, "tax_value");
            }}
            value={data?.tax_value}
            status={
              missingFields
                ?.find((item) => index === item?.index)
                ?.missingFields?.includes("tax_value")
                ? "error"
                : ""
            }
          >
            {[0, 5, 12, 18, 28]?.map((each, index) => (
              <Option key={index} value={each}>
                {each}
              </Option>
            ))}
          </Select>
          {/* <Select
            className="item-input-table"
            onChange={(e) => {
              // onChange(e, data, "tax_type");
              handleSave({ ...data, tax_type: e });
            }}
            value={data?.tax_type ?? "cgst_sgst"}
          >
            {taxTypes?.map((each) => (
              <Option key={each.id} value={each.value}>
                {each.label}
              </Option>
            ))}
          </Select> */}
          {/* <span>Budget : {data?.budget_price}</span> */}
        </Space>
      ),
    },
    {
      title: "Rate (w/ gst)",
      // dataIndex: "total",
      width: 140,
      render: (data) => {
        var total = parseFloat(
          (parseFloat(data?.unit_selling_price, 2) +
            parseFloat(data?.unit_selling_price, 2) *
              (parseFloat(data?.margin, 2) / 100)) *
            ((parseFloat(data?.tax_value, 2) + 100) / 100)
        );
        return (
          <span className="item-input-table" style={{ minWidth: 140 }}>
            {total?.toFixed(2)}
          </span>
        );
      },
    },
    {
      title: "Amount (w/ gst)",
      // dataIndex: "total",
      render: (data) => {
        var total =
          parseFloat(data?.quantity, 2) *
          ((parseFloat(data?.unit_selling_price, 2) +
            parseFloat(data?.unit_selling_price, 2) *
              (parseFloat(data?.margin, 2) / 100)) *
            ((parseFloat(data?.tax_value, 2) + 100) / 100));
        console.log(
          "total",
          total,
          data?.quantity,
          parseFloat(data?.quantity, 2)
        );
        return (
          <span className="item-input-table" style={{ minWidth: 80 }}>
            {total?.toFixed(2)}
          </span>
        );
      },
    },
    {
      title: "Image",
      // dataIndex: "total",
      render: (value, data, index) => (
        <>
          {data?.item_image && data?.item_image != "" && (
            <img src={data?.item_image} alt="item" className="quote-item-img" />
          )}
        </>
      ),
    },
    {
      title: "Action",
      // dataIndex: "action",
      render: (_, record, index) =>
        dataSource.length >= 1 ? (
          <Row style={{ minWidth: 150 }}>
            <ImageUpload
              key={record?.id ?? index}
              onDocumentAdd={onDocumentAdd}
              index={index}
              dataSource={dataSource}
              setDataSource={setDataSource}
              record={record}
              loading={fileUploading}
            />
            <Tag
              color="red"
              style={{
                cursor: "pointer",
              }}
              onClick={() => {
                handleDelete(record.id);
              }}
            >
              Delete
            </Tag>
          </Row>
        ) : null,
    },
  ];
  const handleSave = (row) => {
    console.log(row);
    const newData = [...dataSource];
    const index = newData.findIndex((item) => row.id === item.id);
    const item = newData[index];
    console.log(item);
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setDataSource(newData);
  };
  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };
  const columns = defaultColumns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
      }),
    };
  });
  return (
    <Table
      components={components}
      bordered
      rowKey={(record) => record.id}
      scroll={{ x: "100%" }}
      dataSource={dataSource}
      columns={columns}
      pagination={false}
    />
  );
};

export default EditableItemTable;
